import { render, staticRenderFns } from "./dubletten-filter-panel.vue?vue&type=template&id=00bc21a9&scoped=true"
import script from "./dubletten-filter-panel.vue?vue&type=script&lang=js"
export * from "./dubletten-filter-panel.vue?vue&type=script&lang=js"
import style0 from "./dubletten-filter-panel.vue?vue&type=style&index=0&id=00bc21a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc21a9",
  null
  
)

export default component.exports